module.exports = __webpack_public_path__ + "img/62.1f71ee61.jpg";